import { ListOrdersDto } from "types/dto/ListOrdersDto"
import { ApiService } from "./apiService"



export const getOrders = async (dto: ListOrdersDto) => {
    if (dto.status && dto.status !== 'all') {
        return ApiService.get(`orders?page=${dto.page}&size=${dto.size}&status=${dto.status}`);
    }
    return ApiService.get(`orders?page=${dto.page}&size=${dto.size}`);
}

// Reminds now every customer with something unrated, without the daily wait.
export const sendReviewReminders = async (): Promise<{ customers: number }> => {
    return ApiService.post(`orders/review-reminders`, {});
}